<template>
    <div class="niigmiinTvnshlel">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="title">Нийгмийн түншлэл</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="niigmiinTvnshlel_tab">
                        <Tabs value="name1">
                            <TabPane label="ТӨСӨЛ ХӨТӨЛБӨР" name="name1">
                              <div class="niigmiinTvnshlel_table _center">
                                <a href="https://vetp.mn/төслүүд" target="_blank">
                                  <img src="../assets/item/bank-check.png">
                                  <p>Төсөл хөтөлбөр <i class="fa fa-arrow-right" aria-hidden="true"></i></p>
                                </a>
                              </div>
<!--                                <div class="niigmiinTvnshlel_table" v-show="!showForm">-->
<!--                                    <table width="100%">-->
<!--                                        <thead>-->
<!--                                        <tr>-->
<!--                                            <th>№</th>-->
<!--                                            <th>ТӨСЛИЙН НЭР</th>-->
<!--                                            <th>ТӨСӨЛ ХЭРЭГЖҮҮЛЭГЧ БАЙГУУЛЛАГА</th>-->
<!--                                            <th>ТОВЧОО</th>-->
<!--                                            <th>ТӨСӨВ</th>-->
<!--                                            <th></th>-->
<!--                                        </tr>-->
<!--                                        </thead>-->
<!--                                        <tbody>-->
<!--                                        <tr :key="index" v-for="(tusul, index) in tusuls">-->
<!--                                            <td>-->
<!--                                                <span v-if="current_page == 1">{{index+1}}</span>-->
<!--                                                <span v-else>{{((current_page-1)*9)+(index+1)}}</span>-->
<!--                                            </td>-->
<!--                                            <td>{{tusul.ner}}</td>-->
<!--                                            <td>{{tusul.th_baiguullaga}}</td>-->
<!--                                            <td>{{tusul.tovchoo}}</td>-->
<!--                                            <td>{{tusul.tosov}}</td>-->
<!--                                            <td><a href="#" @click="showForm = !showForm" class="button">Үзэх</a></td>-->
<!--                                        </tr>-->

<!--                                        </tbody>-->
<!--                                    </table>-->
<!--                                </div>-->
<!--                                <div class="details_screen" v-show="showForm">-->
<!--                                      <div class="row">-->
<!--                                          <div class="col-md-12">-->
<!--                                              <Button  class="button" @click="showForm = !showForm" ><i class="fa fa-arrow-circle-left"></i>Буцах</Button>-->
<!--                                          </div>-->
<!--                                      </div>-->
<!--                                      <div class="row">-->
<!--                                           <div class="col-md-6">-->
<!--                                               <div class="left">-->
<!--                                                   <img src="../assets/niigem.png" alt="">-->
<!--                                               </div>-->
<!--                                           </div>-->
<!--                                           <div class="col-md-6">-->
<!--                                               <div class="right">-->
<!--                                                   <h3>Ур чадварыг бэхжүүлэх</h3>-->
<!--                                                   <div class="item">-->
<!--                                                       <h4>Улс / Бүс нутаг :</h4>-->
<!--                                                       <p>Вэб дизайн хуурамч текст</p>-->
<!--                                                   </div>-->
<!--                                                   <div class="item">-->
<!--                                                       <h4>Чиглэл :</h4>-->
<!--                                                       <p>Вэб дизайн хуурамч текст</p>-->
<!--                                                   </div>-->
<!--                                                   <div class="item">-->
<!--                                                       <h4>Хугацаа :</h4>-->
<!--                                                       <p>2020.09.09-2021.01.12</p>-->
<!--                                                   </div>-->
<!--                                                   <div class="item">-->
<!--                                                       <h4>Хамтрагч байгууллага :</h4>-->
<!--                                                       <p>Вэб дизайн хуурамч текст ашиглах нэг хязгаарлалт энэ текстийг уншиж хэзээ ч гэсэн, энэ нь түүний бодит ойлгомжтой шалгах биш юм байна.</p>-->
<!--                                                   </div>-->
<!--                                                   <div class="item">-->
<!--                                                       <h4>Зорилтууд :</h4>-->
<!--                                                       <p>Вэб дизайн хуурамч текст ашиглах нэг хязгаарлалт энэ текстийг уншиж хэзээ ч гэсэн.</p>-->
<!--                                                   </div>-->
<!--                                                   <div class="item">-->
<!--                                                       <h4>Үр дүн :</h4>-->
<!--                                                       <p>Вэб дизайн хуурамч текст ашиглах нэг хязгаарлалт энэ текстийг уншиж хэзээ ч гэсэн, энэ нь түүний бодит ойлгомжтой шалгах биш юм байна.</p>-->
<!--                                                   </div>-->

<!--                                               </div>-->
<!--                                           </div>-->
<!--                                      </div>-->
<!--                                </div>-->
<!--                                <div class="pagenation" v-show="!showForm">-->
<!--                                    <Page  @on-change="changePageTusul"-->
<!--                                           :current-page="current_page"-->
<!--                                           :page-size="9"-->
<!--                                           :total="total"-->
<!--                                    />-->
<!--                                </div>-->
                            </TabPane>
                            <TabPane label="ТӨРИЙН БУС БАЙГУУЛЛАГУУД" name="name2">
                                <turiinBusBaiguullaga></turiinBusBaiguullaga>
                            </TabPane>
                            <TabPane label="АЖ АХУЙ НЭГЖ БАЙГУУЛЛАГА" name="name3">
                                <AjAhuiNegj></AjAhuiNegj>
                            </TabPane>
                            <TabPane label="МЭРГЭЖЛИЙН ЗӨВЛӨЛ" name="name4">
                                <mergejliinZuvluh></mergejliinZuvluh>
                            </TabPane>
                        </Tabs>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getTosolHotolbor} from "../api/index"
    import turiinBusBaiguullaga from './section/turiinBusBaiguullaga';
    import AjAhuiNegj from './section/AAN';
    import mergejliinZuvluh from './section/mergejliin_zuvluh';
    export default {

        components: {
            AjAhuiNegj: AjAhuiNegj,
            turiinBusBaiguullaga: turiinBusBaiguullaga,
            mergejliinZuvluh: mergejliinZuvluh,
        },
        data () {
            return {
                showForm:false,
                tusuls: [],
                current_page:1,
                last_page:1,
                total:0,
            }
        },
        mounted () {

              this.calldata();
        },
        methods: {
            calldata(){
                this.$isLoading(true);
                getTosolHotolbor(this.current_page).then(response=>{
                    this.tusuls = response.data.data;
                    this.current_page = response.data.current_page;
                    this.total = response.data.total;
                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
            },
            changePageTusul(page) {
                this.current_page = page;
                this.calldata();
            },
        },

    }
</script>
